module.exports = __webpack_public_path__ + "static/img/waigou.ac39f77.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/waigou.jpeg
// module id = Bk63
// module chunks = 1